import React, { Component } from "react";

import { ajaxWrapper, setGlobalState } from "functions";
import { Loading } from "library";

class ContextLoader extends Component {
	constructor(props) {
		super(props);
		this.state = { loaded: false };
	}

	componentDidMount() {
		ajaxWrapper("GET", "/users/user/", {}, this.load_user);
	}

	load_user = (value) => {
		setGlobalState("user", value);
		this.setState({
			loaded: true,
		});
	};

	render() {
		return <Loading loaded={this.state.loaded}>{this.props.children}</Loading>;
	}
}

export default ContextLoader;
